export class AdminOptionsLang {
    public CheckInDelayDescription: string;
    public CheckInDelayTitle: string;
    public CheckInInactivityDelayDescription: string;
    public CheckInInactivityDelayTitle: string;
    public DisplayProfilePictureDescription: string;
    public DisplayProfilePictureTitle: string;
    public HealthCardExpiryStopDescription: string;
    public HealthCardExpiryStopTitle: string;
    public LatenessDelayDescription: string;
    public LatenessDelayTitle: string;
    public MaximumTimeGapBetweenCheckedInAppointmentsDescription: string;
    public MaximumTimeGapBetweenCheckedInAppointmentsTitle: string;
    public PersonalInformationModificationOptionDescription: string;
    public PersonalInformationModificationOptionTitle: string;
    public RegionCodeConfirmationOptionDescription: string;
    public RegionCodeConfirmationOptionTitle: string;
    public PreferredPharmacyModificationOptionDescription: string;
    public PreferredPharmacyModificationOptionTitle: string;
    public SelectSessionTimeSpanInstruction: string;
    public SessionTimeSpanTitle: string;
}


// WEBPACK FOOTER //
// ./src/resources/AdminOptionsLang.ts